import React, { Component, PropTypes } from 'react';

let didLoadDisqusScript = false;

function copyProps(context, props, prefix = '') {
  Object.keys(props).forEach((prop) => {
    context[prefix + prop] = props[prop];
  });
}

export default class DisqusComments extends Component {
  static propTypes = {
    shortname: PropTypes.string.isRequired,
    identifier: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    category_id: PropTypes.string
  }

  componentDidMount() {
    this.loadDisqus();
  }

  addDisqusScript() {
    if (!didLoadDisqusScript) {
      const child = this.disqus = document.createElement('script');
      const parent = document.getElementsByTagName('head')[0] ||
        document.getElementsByTagName('body')[0];

      child.async = true;
      child.type = 'text/javascript';
      child.src = 'https://' + this.props.shortname + '.disqus.com/embed.js';

      parent.appendChild(child);
      didLoadDisqusScript = true;
    }
  }

  loadDisqus() {
    const DISQUS = window['DISQUS'];
    const props = this.props;

    if (typeof DISQUS !== 'undefined') {
      // If Disqus has already been added, reset it
      DISQUS.reset({
        reload: true,
        config: function config() {
          copyProps(this.page, props);
        }
      });
    } else {
      copyProps(window, props, 'disqus_');
      this.addDisqusScript();
    }
  }

  render() {
    return (
      <div>
        <div id="disqus_thread"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/social/DisqusComments.js